export default __webpack_public_path__ + "7af8fbf3867ef1f4b79dc9afb954210b.svg";